import { type ReactElement } from 'react'
import { Box } from '@mui/material'
import { formatKn } from '../utils'

interface Props {
  label: string
  force: number
}

/** One `min.:` / `max.:` line below a full-load reaction. */
export const CharacteristicSupportReactionRangeRow = ({ label, force }: Props): ReactElement => (
  <Box
    sx={{ fontSize: 11, color: 'text.secondary', whiteSpace: 'nowrap' }}
    data-cy="characteristic-support-reaction-range"
  >
    {label} {formatKn(force)}
  </Box>
)
